import {decorate, inject, injectable} from '@yosmanyga/di'
import {AbstractSecureStorage, SecureStorage} from '@yosmanyga/abstract-secure-storage'
import {Dispatcher} from './Dispatcher'

class LanguageManager {
    private language!: string | null

    constructor(
        private secureStorage: SecureStorage,
        private dispatcher: Dispatcher
    ) {
    }

    load = async () => {
        const language = await this.secureStorage.get('language')

        this.language = language || null
    }

    get = (): string | null => {
        if (typeof this.language === 'undefined') {
            throw new Error();
        }

        return this.language
    }

    save = async (
        language: string
    ) => {
        await this.secureStorage.set('language', language)

        await this.load();

        this.dispatcher.retrieve<(language: string) => void>('language_saved').map(service => service(language))
    }

    delete = async () => {
        await this.secureStorage.delete('language')

        await this.load();

        this.dispatcher.retrieve<() => void>('language_deleted').map(service => service())
    }
}

decorate(injectable(), LanguageManager)
decorate(inject(AbstractSecureStorage), LanguageManager, 0)
decorate(inject(Dispatcher), LanguageManager, 1)

export {
    LanguageManager
}
